import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTrailerById, deleteTrailer } from "../../../store/trailers";
import VehicleComponent from "../../../components/reusable/vehicleComponent/VehicleComponent";
import LocationHistory from "../../../components/trailers/locationHistory/LocationHistory";
import UserAssignmentHistory from "../../../components/trailers/userAssignmentHistory/UserAssignmentHistory";
import './TrailerDetail.css'
import { useHistory } from "react-router-dom";
import { hasManagerAccess } from "../../../utils/permissions";
import { useLoadAppData } from "../../../hooks/useLoadAppData";

const TrailerDetail = () => {
  const { id } = useParams(); // Get trailer ID from URL
  const dispatch = useDispatch();
  const history = useHistory();
  const sessionUser = useSelector((state) => state.session.user);
  const [trailer, setTrailer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Use the hook to load all app data including users
  const isAppDataLoading = useLoadAppData();

  useEffect(() => {
    const fetchTrailer = async () => {
      try {
        const trailerData = await dispatch(getTrailerById(id));
        if (trailerData) {
          setTrailer(trailerData);
          setError(null);
        } else {
          setError('Trailer not found');
          setTrailer(null);
        }
      } catch (error) {
        setError('Error loading trailer');
        setTrailer(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTrailer();
    } else {
      setError('No trailer ID provided');
      setLoading(false);
    }
  }, [id, dispatch]);

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this trailer?')) {
      try {
        await dispatch(deleteTrailer(id));
        history.push('/');
      } catch (error) {
        console.error('Error deleting trailer:', error);
      }
    }
  };

  if (loading || isAppDataLoading) return <div>Loading...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;
  if (!trailer) return <div className="error-message">Trailer not found</div>;

  return (
    <div className="trailerDetail">
    <div className="trailerDetail--wrapper">
      <div className="trailerDetail--top">
       <h2 className="trailerDetail--heading">Trailer Detail</h2>
       <div className="trailerDetail--imageButton">
          <img
            src={
            trailer?.is_loaded
            ? "/images/trailer-loadedYard.jpeg"
            : trailer?.is_tray
            ? "/images/trailer-traysFull.jpeg"
            : "/images/trailer-empty.jpeg"}
            alt=""
            className="trailerDetail--img"
            />
          </div>
      </div>
      <VehicleComponent data={trailer}/>

      <div className="flex items-center mb-8 justify-between w-full">
        <button
          onClick={() => history.push('/')}
          className="px-8 py-4 mr-10 text-3xl text-gray-700 bg-gray-200 rounded-lg transition-all duration-200
            hover:bg-gray-300 hover:shadow-md hover:scale-[1.02]"
        >
          Back
        </button>
        <div className="space-x-4">
          {hasManagerAccess(sessionUser) && (
            <button id=""
              onClick={handleDelete}
              className="px-6 py-3 text-2xl text-white bg-red-500 rounded-lg transition-all duration-200
                hover:bg-red-600 hover:shadow-md hover:scale-[1.02]"
            >
              Delete
            </button>
          )}
          <button id=""
            onClick={() => history.push(`/trailers/${id}/edit`)}
            className="inline-block px-6 py-3 text-2xl text-white bg-blue-500 rounded-lg transition-all duration-200
              hover:bg-blue-600 hover:shadow-md hover:scale-[1.02]"
          >
            Update
          </button>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-10 mt-6">
        {/* User Assignment History Section */}
        <UserAssignmentHistory userHistory={trailer.user_history} />

        {/* Location History Section */}
        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="text-4xl font-semibold mb-4">Location History</h3>
          <LocationHistory trailerId={id} />
        </div>
      </div>
    </div>
  </div>
  );
};

export default TrailerDetail;
